/**
 * Alerts
 */
require('./alerts/alerts');

/**
 * Clients
 */
require('./clients/domains');
require('./clients/commissions');
require('./clients/users');
require('./clients/clients');
require('./clients/targets');
require('./clients/reporting');
require('./clients/reports');
require('./clients/operation-emails');
require('./clients/onboarding-notes');
require('./clients/plusvibe');

/**
 * Users
 */
require('./users/manage-emails');
require('./users/schedule');
require('./users/holiday');

/**
 * Password
 */
require('./password/password-field');
require('./password/reset-password');
require('./password/request-password-reset');

/**
 * Quotes
 */
require('./quotes/sales');
require('./quotes/edit');
require('./quotes/url');
require('./quotes/country');
require('./quotes/address');
require('./quotes/vue-select');
require('./quotes/appointment');
require('./quotes/mass-email');
require('./quotes/quote-fields');

// Campaign
require('./quotes/campaign/manage');
require('./quotes/campaign/create');
require('./quotes/campaign/edit');

/**
 * Dashboards
 */
require('./dashboards/client-stats');
require('./dashboards/sales-pipeline');
require('./dashboards/date-picker');
require('./dashboards/activity-graph');
require('./dashboards/bar-chart');
require('./dashboards/doughnut-chart');
require('./dashboards/gauge');
require('./dashboards/live-stats');
require('./dashboards/powerhour-stats');
require('./dashboards/fireworks');
require('./dashboards/clock');

/**
 * Sales
 */
require('./sales/sales-dashboard');


/**
 * Tasks/Calendar
 */
require('./tasks/calendar');

/**
 * Imports
 */
require('./import/import-leads');

/**
 * Quiz
 */
require('./quiz/create-quiz');
require('./quiz/manage-questions');
require('./quiz/create-question');
require('./quiz/quizzes');

/**
 * Telesales
 */
require('./telesales/response');

/**+
 * Files
 */
require('./files/files');

/**
 * Dashboard
 */
require('./dashboard/notes');
require('./dashboard/dashboard-targets');

/**
 * Schedule
 */
require('./schedules/schedules');

/**
 * Holiday
 */
//require('./holidays/holidays');

require('./holidays/holidays-calendar');

/**
 * Settings
 */
require('./settings/powerhour');

/**
 * Commissions
 */
require('./commissions/commissions');

/**
 * Menus
 */
require('./menu/menu');

/**
 * Reports
 */
require('./reports/reports');

/**
 * Meeting Calendar
 */
require('./meetings/calendar');

/**
 * Operations
 */
require('./ops/settings');
require('./ops/appointment-results');

/**
 * Performance
 */
require('./performance/performance');

/**
 * Information
 */
require('./information/information');